import React from 'react';
import BaseModal from './BaseModal';
import { formatDateTimeCL } from '../../utils/dateTimeChile';
import './AuditInfoModal.css';

export type AuditInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  createdByName?: string | null;
  updatedByName?: string | null;
};

const AuditInfoModal: React.FC<AuditInfoModalProps> = ({
  isOpen,
  onClose,
  title = 'Historial del registro',
  createdAt,
  updatedAt,
  createdByName,
  updatedByName,
}) => {
  if (!isOpen) return null;

  const userLabel = (name?: string | null) =>
    name && name.trim() ? name.trim() : '—';

  return (
    <BaseModal title={title} onClose={onClose}>
      <div className="audit-info-modal">
        <section className="audit-info-modal__block">
          <h3 className="audit-info-modal__heading">Creación</h3>
          <dl className="audit-info-modal__list">
            <div className="audit-info-modal__row">
              <dt>Fecha</dt>
              <dd>{formatDateTimeCL(createdAt)}</dd>
            </div>
            <div className="audit-info-modal__row">
              <dt>Usuario</dt>
              <dd>{userLabel(createdByName)}</dd>
            </div>
          </dl>
        </section>
        <section className="audit-info-modal__block">
          <h3 className="audit-info-modal__heading">Última actualización</h3>
          <dl className="audit-info-modal__list">
            <div className="audit-info-modal__row">
              <dt>Fecha</dt>
              <dd>{formatDateTimeCL(updatedAt)}</dd>
            </div>
            <div className="audit-info-modal__row">
              <dt>Usuario</dt>
              <dd>{userLabel(updatedByName)}</dd>
            </div>
          </dl>
        </section>
        <div className="audit-info-modal__actions">
          <button type="button" className="btn-create" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </BaseModal>
  );
};

export default AuditInfoModal;
